// @flow
import React, { Component } from "react";
import styled from "styled-components";
import * as squadTypes from "squadTypes";

import { request } from "state/utils";
import { getSubdomain } from "state/utils/url";
import _ from "lodash";

// Components
import IconPage from "v2/components/svg/IconPage";
import Loader from "v2/components/Loader";
import { Link } from "react-router-dom";

const Container = styled.div`
  li {
    a {
      align-items: flex-start;
    }
  }
`;

type Props = {
  query: ?string,
  hideForm: Function
};

type State = {
  isFetching: boolean,
  projects: Array<squadTypes.Project>
};

class PageSearch extends Component<Props, State> {
  state = {
    isFetching: true,
    projects: []
  };

  debouncedFetchProjects: Function;

  constructor(props: Object) {
    super(props);
    this.debouncedFetchProjects = _.debounce(this._fetchProjects, 300);
    this.debouncedFetchProjects(this.props.query);
  }

  componentDidUpdate(prevProps: Object) {
    if (this.props.query !== prevProps.query) {
      this.debouncedFetchProjects(this.props.query);
    }
  }

  // This function is going to fetch the list of goal using the value of the input as a starting point.
  _fetchProjects = (query: ?string) => {
    if (!query) {
      this.setState({
        projects: [],
        isFetching: false
      });
      return;
    }
    // Get the current subdomain as it'll be used in the API path
    const slug = getSubdomain() || "";
    const projectsApiURL = `/workspaces/${slug}/projects/`;
    let projectsParams = {
      title: query,
      limit: 8
    };
    this.setState({ isFetching: true });
    request.get(projectsApiURL, { params: projectsParams }).then(response => {
      const projects = response.data;
      this.setState({
        projects,
        isFetching: false
      });
    });
  };

  render() {
    const { isFetching, projects } = this.state;
    if (!isFetching && projects.length === 0) {
      return (
        <Container>
          <b>Pages</b>
          <div className="no-results">
            <Link to={`/pages`} onClick={this.props.hideForm}>
              View all pages
            </Link>
          </div>
        </Container>
      );
    }
    return (
      <Container>
        <b>Pages</b> {isFetching && <Loader size="small" />}
        {!isFetching && (
          <ul>
            {projects.map(project => (
              <li key={project.id}>
                <Link to={`/pages/${project.id}`} className="flex-start" onClick={this.props.hideForm}>
                  <IconPage />
                  <div>
                    <span>{project.title}</span>
                    <br />
                    {project.path && <small className="light">{project.path.label}</small>}
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </Container>
    );
  }
}

export default PageSearch;
